<template>
<div class="">
    <HomeSlider />
    <!-- Service -->
    <section class="servicesec pt-0 bg-light">
        <div class="container">
            <div class="row">
                <div class="col-12 col-md-12">
                    <div id="service-slider" class="swiper-container">
                        <div class="swiper-wrapper">
                            <div class="swiper-slide">
                                <a href="/events">
                                    <div class="service-block bg-cover" :style="{'background-image': 'url(' + require('../assets/images/news2.jpg') + ')'}">
                                        <div class="service-content text-center text-white position-relative">
                                            <h5 class="mb-0">Upcoming Event & Updates</h5>
                                        </div>
                                    </div>
                                </a>
                            </div>
                            <div class="swiper-slide">
                                <a href="/coming-soon">
                                    <div class="service-block bg-cover" :style="{'background-image': 'url(' + require('../assets/images/news1.jpg') + ')'}">
                                        <div class="service-content text-center text-white position-relative">
                                            <flip-countdown deadline="2020-09-24 19:00:00"></flip-countdown>
                                            to next live streaming
                                        </div>
                                    </div>
                                </a>
                            </div>
                            <div class="swiper-slide">
                                <a href="/videos">
                                    <div class="service-block bg-cover" :style="{'background-image': 'url(' + require('../assets/images/news3.jpg') + ')'}">
                                        <div class="service-content text-center text-white position-relative">
                                            <h5 class="mb-0">Latest Videos</h5>
                                        </div>
                                    </div>
                                </a>
                            </div>
                            <div class="swiper-slide">
                                <a href="/bible-school">
                                    <div class="service-block bg-cover" :style="{'background-image': 'url(' + require('../assets/images/news2.jpg') + ')'}">
                                        <div class="service-content text-center text-white position-relative">
                                            <h5 class="mb-0">Amfcc Bible School</h5>
                                        </div>
                                    </div>
                                </a>
                            </div>
                            <div class="swiper-slide">
                                <a href="/audio-media">
                                    <div class="service-block bg-cover" :style="{'background-image': 'url(' + require('../assets/images/news1.jpg') + ')'}">
                                        <div class="service-content text-center text-white position-relative">
                                            <h5 class="mb-0">Latest Media</h5>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <!-- Add Pagination -->
                        <div class="swiper-pagination"></div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- End Service -->
    <!-- Main-content -->
    <section class="maincontent main-top">
        <div class="container"> <!-- Top container starts here -->
            <div class="row">
                <div class="col-12 col-lg-6">
                    <div class="card rounded-0 text-center main-block border-1">
                        <div class="card-body p-0">
                            <div class="card-header rounded-0 bg-primary py-3"><h5 class="mb-0 text-white">Featured Videos</h5></div>
                            <div class="card-body" v-for="videos in media.slice(0, 1)" :key="videos.nid">
                                <!-- based on https://morioh.com/p/487a79571ccb -->
                                <video-embed :params="{autoplay: 0}" v-bind:src="videos.field_video_media"></video-embed>
                                <router-link class="nav-link" to="/audio-media"> Watch More Views </router-link>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-lg-6">
                    <div class="row">
                        <div class="col-12 col-md-6 col-lg-12 col-xl-6 mb-4">
                            <HomeLinks />

                        </div>
                        <div class="col-12 col-md-6 col-lg-12 col-xl-6 mb-4">
                            <EventsTeaser />
                        </div>
                    </div>
                </div>
            </div>
        </div> <!-- Top container starts here -->

    </section>
    <!-- Main-content -->
    <section class="maincontent main-middle">
        <div class="container"> <!-- Top container starts here -->
            <div class="row">
                <div class="col-12 col-12 col-lg-12 mb-5 mb-lg-0">
                    <div class="card rounded-0 text-center main-block border-0">
                        <div class="card-body p-0">
                            <LatestLargeArticles />
                        </div>
                    </div>
                </div>
            </div>
        </div> <!-- Top container starts here -->

    </section>
    <!-- End Main-content -->
</div>

</template>


<script>
import axios from 'axios';
import Vue from 'vue';
// @ is an alias to /src
import HomeSlider from '@/components/HomeSlider';
import Swiper from 'swiper';
import EventsTeaser from "../components/Events/EventsTeaser";
import HomeLinks from "../components/HomeLinks/HomeLinks";
import FlipCountdown from 'vue2-flip-countdown';
import Embed from 'v-video-embed';
import LatestLargeArticles from "../components/LatestLargeArticles/LatestLargeArticles";

// global register
Vue.use(Embed);
export default {
    name: 'Home',
    data(){
        return {
            serviceSlider: null,
            testimonialSlider: null,
            marquee: "",
            events: [],
            bgImage: "/staging/img/worship.5505013e.jpg",
            media: []
        }
    },
    components:{
        HomeSlider, EventsTeaser, HomeLinks, FlipCountdown, LatestLargeArticles
    },
    mounted() {
        //Service Slider
        this.serviceSlider = new Swiper('#service-slider', {
            // Optional parameters
            autoplay: {
                delay: 12500,
                disableOnInteraction: false,
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            breakpoints: {
                681: {
                    slidesPerView: 2,
                },
                1024: {
                    slidesPerView: 3,
                },
            }
        });

        //Testimonial Slider
        this.testimonialSlider = new Swiper('#testimonial-slider', {
            // Optional parameters
            speed: 100,
            parallax: true,
            autoplay: {
                delay: 16500,
                disableOnInteraction: false,
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
                renderBullet: function (index, className) {
                    return '<span class="' + className + '">' + (index + 1) + '</span>';
                },
                type: 'progressbar',
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        });

        axios
        .get('https://api.fifmi.org.au/api/events')
        .then(result => {
            for (var i = 0; i < result.data.length; i++) {
                if(result.data[i].field_domain_access.includes('fifmi') && result.data[i].type == "events" && result.data[i].type == "article"){
                    this.events.push(result.data[i])
                }
            }
        });
        axios
            .get('https://api.fifmi.org.au/api/media')
            .then(result => {
                for (var i = 0; i < result.data.length; i++) {
                    if(result.data[i].field_domain_access.includes('fifmi') && result.data[i].field_media_type === "Videos"){
                        this.media.push(result.data[i])
                    }
                }
            });
    }
}
</script>
